import {
  CalendarIcon,
  ClipboardCheckmarkIcon,
  DollarIcon,
  DropletIcon,
  FinanceReportIcon,
} from '~components/icons'
import { ReactNode } from 'react'

export const reportTypes = [
  'Payment Report',
  'Earnings Report',
  'Bunker Adjustment Report',
  'Pool Days Report',
  'Allocated Result Report',
] as const

export type ReportType = (typeof reportTypes)[number]

export interface ReportTileProps {
  icon?: ReactNode
  title: string
  description: string
  reportType: ReportType
}

export interface HelpBoxProps {
  headline: string
  text: string
  linkText: string
  link: string
}

export const iconProps = {
  width: '28px',
  height: '28px',
}

const reportTiles: ReportTileProps[] = [
  {
    icon: <FinanceReportIcon {...iconProps} />,
    title: 'Payment',
    description:
      'Payment reports shows paid out amounts on YTD basis in chosen calendar year.',
    reportType: 'Payment Report',
  },
  {
    icon: <DollarIcon {...iconProps} />,
    title: 'Earnings',
    description:
      'Earnings report shows the TCE overview with a split into various elements.',
    reportType: 'Earnings Report',
  },
  {
    icon: <DropletIcon {...iconProps} />,
    title: 'Bunker Adjustment',
    description: 'The report shows most recent Bunker Adjustment amount.',
    reportType: 'Bunker Adjustment Report',
  },
  {
    icon: <CalendarIcon {...iconProps} />,
    title: 'Pool Days',
    description: 'Overview of on-hire and off-hire days per vessel.',
    reportType: 'Pool Days Report',
  },
  {
    icon: <ClipboardCheckmarkIcon {...iconProps} />,
    title: 'Allocated Result',
    description:
      'Reports provides information on actual and allocated results.',
    reportType: 'Allocated Result Report',
  },
]

const helpBox: HelpBoxProps = {
  headline: 'Get the most out of the pool finance reports',
  text: 'Check our frequently asked questions to learn more about the financial reports and how to find the information you need.',
  linkText: 'Learn more',
  link: '/help/finance-and-reporting',
}

export const content = {
  pageName: 'Reports',
  reportTiles,
  helpBox,
}
